import {Component, OnInit, Inject} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Router} from '@angular/router';
import {ApiService, MessagesService} from '@angular/synthrone-design/services';
import {APP_CONFIG} from '@synthroneApp/app.config';
import {MatDialog} from '@angular/material';
import {AttributeModel} from '@synthroneApp/models/attribute/attribute.model';

@Component({
    selector: 'app-attribute-add-view',
    templateUrl: './attribute-add-view.component.html',
    styleUrls: ['./attribute-add-view.component.scss']
})

export class AttributeAddViewComponent implements OnInit {

    dataId: number;
    isLoading = true;
    actionName: string;
    public attribute: AttributeModel;
    public attributeTypes: string[];
    isDataLoading = false;

    constructor(private _router: Router, protected api: ApiService,
                private messagesService: MessagesService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog) {
        this.actionName = (this._router.url.includes('add') ? 'Add' : 'Edit');
    }

    ngOnInit() {
        this.attribute = {
            name: '',
            label: '',
            type: ''
        };

        this.attributeTypes =  [
            'string', 'integer'
        ];

        if (this.actionName === 'Edit') {
            this.dataId = parseInt((this._router.url).match(/\d+/)[0]);
            this.api.makeRequest('api_system_attribute_details', {
                id: this.dataId
            }, 'crafter').subscribe(
                (result) => {
                    this.attribute = {
                        name: result['name'].toString(),
                        label: result['label'].toString(),
                        type: result['type'].toString()
                    };
                    this.isLoading = false;
                },
                (error) => {
                    this.isLoading = false;
                    this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(result => {
                        this.homeReturnFN();
                    });
                });
        } else {
            this.isLoading = false;
        }
    }

    homeReturnFN = () => {
        this._router.navigate(['/attributes']);
    };

    createOrgFN = () => {
        this.api.makeRequest('api_system_attribute_create', {
            'jsonPayload': this.attribute
        }, 'crafter').subscribe(
            (result) => {
                this.isLoading = false;
                this.homeReturnFN();
            },
            (error) => {
                this.isLoading = false;
                this.messagesService.showSnack(error, 'error');
            });
    };

    editOrgFN = () => {
        this.isLoading = true;
        this.api.makeRequest('api_system_attribute_put', {
            id: this.dataId,
            'jsonPayload': this.attribute
        }, 'crafter').subscribe(
            (result) => {
                this.isLoading = false;
                this.homeReturnFN();
            },
            (error) => {
                this.isLoading = false;
                this.messagesService.showSnack(error, 'error');
            });
    };

    submitFN(isValid: boolean) {
        if (this.actionName === 'Add') {
            this.createOrgFN();
        } else {
            this.editOrgFN();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/views/attribute-add-view/attribute-add-view.component.ts